// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"872":"7a9024ed","2242":"b61774aa"}[chunkId] + ".chunk.css");